<template>
    <div id="div-production-list" class="production-list">
        <b-card class="card-current-operations">
            <CurrentOperations :site-id="currentSite" :operation-id="$route.params.operation_id" :user-names="userNames" />
        </b-card>
    </div>
</template>

<script>
import { BCard } from 'bootstrap-vue';
import CurrentOperations from './CurrentOperations.vue';

export default {
    components: { BCard, CurrentOperations },
    data() {
        return { currentSite: this.$cookies.get('userInfo').currentSite, userNames: {} };
    },
    mounted() { this.loadUserNames(); },
    methods: {
        async loadUserNames() {
            const map = {};
            const add = (user) => {
                const name = [user.firstName, user.lastName].filter(Boolean).join(" ").trim();
                if (!name) return;
                [user.user, user.email].filter(Boolean).forEach((key) => { map[String(key).trim().toLowerCase()] = name; });
            };
            try {
                const { data } = await this.$http2.get("/api/myconfig/users");
                const list = Array.isArray(data?.data) ? data.data : [];
                list.forEach(add);
            } catch (_) { /* The login stays visible when this list is unavailable. */ }
            try {
                for (let page = 1, pages = 1; page <= pages && page <= 20; page++) {
                    const { data } = await this.$http2.get("/api/myconfig/user", { params: { pageNumber: page, pageSize: 200 } });
                    const payload = data?.data || {};
                    const users = payload.users || [];
                    pages = payload.totalPages || 1;
                    if (!users.length) break;
                    users.forEach(add);
                }
            } catch (_) { /* The login stays visible when this list is unavailable. */ }
            this.userNames = map;
        }
    }
};
</script>

<style lang="scss">
.production-list {
    .card-body {
        padding: 16px;
    }
    .btn-title-action {
        padding: 4px 10px;
        display: flex;
        align-items: center;
        background-color: #ffffff !important;
        color: #974900 !important;
        border-radius: 6px;
        border: 1px solid #974900 !important;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.0125em !important;

        &.is-active,
        &.btn-filled {
            background-color: #974900 !important;
            color: #ffffff !important;

            &:hover,
            &:focus {
                background-color: #8a4300 !important;
                color: #ffffff !important;
            }
        }

        .reload-icon {
            margin-right: 6px;
        }

        .dropdown-icon {
            margin-left: 6px;
        }

        &:hover {
            background-color: #ffede1 !important;
            box-shadow: none !important;
        }

        &.reload {
            svg {
                margin-right: 7px;
            }
        }

        &:focus {
            background-color: transparent !important;
        }
    }
    .close-icon {
        cursor: pointer;
    }
    .separator {
        width: 407px;
        height: 1px;
        background: #cfc4be;
    }
    .sidebar-title {
        font-weight: 600;
        font-size: 18px;
        color: #4c4541;
    }
    .multiselect--disabled {
        .multiselect__single {
            background-color: #f5f5f5 !important;
            opacity: 0.6;
        }
    }
    .multiselect__input {
        border: 1px solid transparent !important;
    }
}

.sidebar-manage-table {
    .b-sidebar-header {
        display: contents;
    }

    .b-sidebar {
        height: 100% !important;
        .b-sidebar-body {
            &::-webkit-scrollbar {
                display: none !important;
            }
        }
    }

    .itens-drag {
        overflow-y: auto;
        height: 100%;
    }

    .info-sidebar {
        padding: 16px;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #998f8a;
    }

    .list-group {
        .list-group-item {
            display: flex;
            align-items: center;
            padding-left: 40px;
            border: none;

            &:hover {
                background-color: #ffede2;
                padding-left: 20px;

                .handle {
                    display: block;
                }
            }

            .handle {
                display: none;
                margin-right: 12px;
            }

            .col-input-icon {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;

                .single-select {
                    width: 100%;

                    .multiselect--disabled {
                        border-radius: 6px;

                        .multiselect__tags {
                            background: #eeeeee !important;
                            border: 1px solid #7e7570 !important;
                        }
                    }
                }

                .name-column {
                    border-radius: 6px !important;
                    border: 1px #d8d6de solid;
                    padding: 7px 10px 7px 10px;

                    &.disabled {
                        background-color: #f5f5f5 !important;
                        opacity: 0.6;
                    }
                }

                .icon-action {
                    margin-left: 8px;
                    padding: 8px 9px;
                    display: flex;
                    align-items: center;

                    &.trash {
                        &:hover {
                            background-color: #ffcdd2;
                            border-radius: 5px;
                        }
                    }
                }
            }
        }
    }

    .footer-sidebar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;

        .btn-footer {
            box-shadow: none;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            border-radius: 5px;

            &:hover {
                box-shadow: none;
            }

            &.btn-reset {
                background-color: transparent !important;
                color: #974900 !important;
                font-size: 12px !important;
                border: 1px solid transparent !important;
                padding: 4px 14px;

                &:hover {
                    background-color: #ffede2 !important;
                }

                &:active {
                    background-color: #ffdbc4 !important;
                }
            }

            &.btn-cancel {
                background-color: transparent !important;
                color: #974900 !important;
                border: 1px solid #974900 !important;
                margin-right: 16px;
                padding: 9px 21px;

                &:hover {
                    background-color: #ffede2 !important;
                }

                &:active {
                    background-color: #ffdbc4 !important;
                }
            }

            &.btn-save {
                border: 1px solid #974900 !important;
                background-color: #974900 !important;
                color: #ffff !important;
                padding: 9px 21px;

                &:hover {
                    background-color: #9f5714 !important;
                }

                &:active {
                    background-color: #a45f1f !important;
                }
            }

            .btn-footer-left {
                display: flex;
            }
        }
    }

    .btn-add-collumn {
        margin-top: 8px;
        margin-left: 16px;
        background-color: transparent !important;
        color: #974900 !important;
        font-size: 12px !important;
        border: 1px solid transparent !important;
        padding: 6px 14px;
        display: flex;
        align-items: center;

        &:hover {
            background-color: #ffede2 !important;
            box-shadow: none !important;
        }

        &:active {
            background-color: #ffdbc4 !important;
        }

        &:disabled {
            background-color: #ece0db !important;
            color: #7e7570 !important;

            svg {
                filter: invert(48%) sepia(4%) saturate(712%) hue-rotate(337deg) brightness(95%)
                contrast(87%) !important;
            }
        }

        .add-circle-icon {
            margin-right: 5px;
        }
    }
}

@media only screen and (min-width: 480px) {
    .restore-icon {
        display: none;
    }
}

@media (max-width: 480px) {
    .b-sidebar {
        width: 100% !important;

        .b-sidebar-body {
            overflow-x: hidden;
        }

        .btn-reset-text {
            display: none;
        }
    }
}

.add-ellipsis-production-p-pcp {
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
